module.exports = __webpack_public_path__ + "static/media/Spoonerism-MT-5.5826d827.mp3";